export default __webpack_public_path__ + "static/media/TysonWieland.6446c972.jpg";